export type BasicInfo = {
  type: string;
  event_id: string;
  deviceId: string;
  distinct_id: string;
  anonymous_id: string;
  time: number;
  timezone_offset: number;
  user_time: string;
  url: string;
  url_host: string;
  url_path: string;
  title: string;
  user_agent: string;
  theme: string;
  lang: string;
  browser_lang: string;
  os_lang: string;
  platform: 'h5' | 'web';
  device_type: 'mobile' | 'PC';
  device_model: string;
  browser: string;
  browser_version: string;
  os: string;
  os_version: string;
};

export enum EmitEvent {
  INVITE_LINK_JUMP = 'invite_link_jump',
  CAMPAIGNIMPRESSION = 'CampaignImpression',
  CAMPAIGNCLICK = 'CampaignClick',
}

export type EmitData = {
  /** 事件名称 */
  event: string;
  /** 事件属性 */
  properties: Record<string, any>;
};

/** 埋点数据 */
export type TrakerData = BasicInfo & EmitData;
